import React from 'react'
import { radius, SurfacePalette, type } from '../tokens'

interface Props {
  palette: SurfacePalette
  children: React.ReactNode
  empty?: boolean
}

export const NarrativeBlock = ({ palette, children, empty }: Props) => (
  <div
    style={{
      padding: '4px 0',
      borderRadius: radius.sm,
      fontFamily: type.family.sans,
      fontSize: type.size.bodyLg,
      lineHeight: 1.55,
      color: empty ? palette.textFaint : palette.text,
      fontStyle: empty ? 'italic' : 'normal',
      whiteSpace: 'pre-wrap',
    }}
  >
    {children}
  </div>
)
